import React, { useContext, useState, useEffect } from "react"
import app from "../firebase";
import "firebase/compat/auth"
import "firebase/compat/firestore"

export const auth = app.auth();
export const db = app.firestore();

const AuthContext = React.createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState()
  const [retailers, setRetailers] = useState([]);
  const [retailerId, setRetailerId] = useState();
  const [retailerName, setRetailerName] = useState();
  const [retailerData, setRetailerData] = useState();

  // todo remove at least these retailer attributes. They are no more needed now that we store the full retailer
  const [retailerFallbackLocationId, setRetailerFallbackLocationId] = useState()
  const [isDeliveryNoteMendatory, setIsDeliveryNoteMendatory] = useState(false) // todo should be retailerIsDeliveryNoteMendatory

  const [loading, setLoading] = useState(true)

  function retailerSelected(retailer) {
    // const retailer = (await db.collection("retailers").doc(id).get()).data();
    console.log("new retailerId "+retailer.id);
    setRetailerId(retailer.id);
    setRetailerName(retailer.name);
    setRetailerData(retailer.data);
    setRetailerFallbackLocationId(retailer.fallbackLocationId);
    setIsDeliveryNoteMendatory(retailer.isDeliveryNoteMendatory);
  }

  function signup(email, password) {
    return auth.createUserWithEmailAndPassword(email, password)
  }

  function login(email, password) {
    return auth.signInWithEmailAndPassword(email, password)
  }

  function logout() {
    return auth.signOut()
  }

  function resetPassword(email) {
    return auth.sendPasswordResetEmail(email)
  }

  function updateEmail(email) {
    return currentUser.updateEmail(email)
  }

  function updatePassword(password) {
    return currentUser.updatePassword(password)
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async user => {
      if(user) {
        const result = await db.collection("retailers").where("merchantIds", "array-contains", user.uid).get();
        const queryDocs = result.docs;
        // console.log("queryDocs.length = " + queryDocs.length);
  
        // a merchant can only be in one retailer. NO MORE TRUE
        // let retailerId = null;
        // let retailerName = null;
        // let retailerFallbackLocationId = null;

        const newRetailers = [];
        let first = true;

        for(let doc of queryDocs) {  
          const id = doc.id;
          const name = doc.get("name");
          const data = doc.data();
          const fallbackLocationId = doc.get("fallbackLocationId");
          const isDeliveryNoteMendatory = doc.get("isDeliveryNoteMendatory");
          
          newRetailers.push({
            id,
            name,
            data,
            fallbackLocationId,
            isDeliveryNoteMendatory
          });

          if(first) {
            setRetailerId(id);
            setRetailerName(name);
            setRetailerData(data);
            setRetailerFallbackLocationId(fallbackLocationId);
            setIsDeliveryNoteMendatory(isDeliveryNoteMendatory);
            first = false;
          }
        }

        // console.log("newRetailers");
        // console.log(newRetailers);

        setRetailers(newRetailers);
        
        // if(queryDocs.length === 1) {
        //   retailerId = queryDocs[0].id;
        //   retailerName = queryDocs[0].get("name");
        //   retailerFallbackLocationId = queryDocs[0].get("fallbackLocationId");
        // }

        setCurrentUser(user);
        // setRetailerId(retailerId);
        // setRetailerName(retailerName);
        // setRetailerFallbackLocationId(retailerFallbackLocationId);
        setLoading(false);
      } else {
        setCurrentUser(user);
        setLoading(false);
      }
    })

    return unsubscribe
  }, [])

  const value = {
    currentUser,
    retailers,
    retailerSelected,
    retailerId,
    retailerData,
    retailerName,
    retailerFallbackLocationId,
    isDeliveryNoteMendatory,
    login,
    signup,
    logout,
    resetPassword,
    updateEmail,
    updatePassword
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}